import { createSelector, Selector } from 'reselect';

import { InitialData } from '@/model/auth/types';
import { RootState } from '@/model/types';

export const makeSelectInitialization = (): Selector<
  RootState,
  { success: boolean; initialized: boolean; loggedOut: boolean; expired: boolean; forbidden: boolean }
> =>
  createSelector(
    (state: RootState) => state.auth,
    ({ initialized, success, loggedOut, forbidden, expired }) => ({
      initialized,
      success,
      loggedOut,
      forbidden,
      expired,
    }),
  );

export const makeSelectAuth = (): Selector<RootState, { success: boolean; isNewUser: boolean; token?: string }> =>
  createSelector(
    (state: RootState) => state.auth,
    ({ isNewUser, token, success }) => ({ isNewUser, token, success }),
  );

export const makeSelectInitialData = (): Selector<RootState, InitialData | undefined> =>
  createSelector(
    (state: RootState) => state.auth.initialData,
    (state) => state,
  );

export default {
  makeSelectAuth,
  makeSelectInitialization,
  makeSelectInitialData,
};
